export type DeviceId = string;

export type DevicePropertyValue = string | string[] | number | number[] | boolean;

export interface DeviceProtocol {
    id: number;
    label: string;
    name: string;
    prefix: string;
    support?: string;
}

export interface StateMetadata {
    unit?: string;
    min?: number;
    max?: number;
    scaleFactor?: string;
    possibleValues?: string[] | number[];
    editable?: boolean;
    defaultValue?: DevicePropertyValue;
}

export interface DeviceState {
    name: string;
    value: DevicePropertyValue;
    type?: string;
    metadata?: StateMetadata;
}

export type DeviceCapability = 'remoteControllerManagement' | 'sensorManagement';

export interface DeviceMS {
    // -----only on Gateway Device -----------
    protocolsactivated?: DeviceProtocol[];
    protocolssupported?: DeviceProtocol[];
    protocolsavailable?: DeviceProtocol[];
    metadata?: unknown;
    // ---------------------------------------
    availability?: string;
    available?: boolean;
    capabilities?: DeviceCapability[];
    details?: { gatewayId: string; softwareVersion: string };
    definition: string;
    categories: string[];
    commercial_name: string; // computed from "profile_io"
    id: DeviceId;
    site_id: string;
    states?: DeviceState[];
    subtype: string;
    type: string;
    uiType: string;
    attributes?: unknown;
    boxurl?: string;
    icon?: string;
    deviceurl?: string;
    name: string; // name given by enduser,
    product_profile?: string;
    protocol_profile?: string;
    activation_date?: string;
    vertical_definition?: string;
    type_id?: number;
    last_update_time?: number;
}

export const DEVICE_COMMANDS = {
    PAIR: 'pair_controller',
    UNPAIR: 'unpair_controller',
    REMOVE_BROKEN_SENSORS: 'remove_broken_sensors',
} as const;
export type DeviceCommand = (typeof DEVICE_COMMANDS)[keyof typeof DEVICE_COMMANDS];

export interface DeviceExecutionCommand {
    // intervention.sessionId
    sessionId: string;
    name: DeviceCommand;
    parameters: { name: string; value: unknown }[];
}

export enum FailureType {
    NO_FAILURE = 'NO_FAILURE',
    ACTUATORNOANSWER = 'ACTUATORNOANSWER',
    ACTUATOR_BUSY = 'ACTUATOR_BUSY',
    ERRORREADWRITEACCESS = 'ERRORREADWRITEACCESS',
    CMDDEPRECATED = 'CMDDEPRECATED',
    INCONSISTENT_ANSWER = 'INCONSISTENT_ANSWER',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    TIME_OUT_ON_QUEUED_COMMAND = 'TIME_OUT_ON_QUEUED_COMMAND',
}

export interface DevicePairingRequest {
    sessionId: string;
    devicesUrls: string[];
}
